export var EmailTemplate;
(function (EmailTemplate) {
    EmailTemplate["NeedMoreDetails"] = "needMoreDetails";
    EmailTemplate["NewFaqReady"] = "newFaqReady";
    EmailTemplate["ContextUpdated"] = "contextUpdated";
    EmailTemplate["NeedLocation"] = "needLocation";
    EmailTemplate["QuestionsListReady"] = "questionsListReady";
    EmailTemplate["FormQuestions"] = "formQuestions";
    EmailTemplate["ReportReady"] = "reportReady";
    EmailTemplate["Welcome"] = "welcome";
    EmailTemplate["VerifiedAnswers"] = "verifiedAnswers";
    EmailTemplate["LawyerConnection"] = "lawyerConnection";
    EmailTemplate["NewLawyerMessage"] = "newLawyerMessage";
})(EmailTemplate || (EmailTemplate = {}));
//# sourceMappingURL=email.js.map